export function BackImageDirective($document) {
    'ngInject';
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            attrs.$observe('bgImage', value => {
                if(value) {
                    let size = attrs.bgSize || 'cover';

                    element.css({
                        'background-image': `url(${value})`,
                        'background-size': size
                    });
                    var style = '<style>[bg-image]:before{background-image:url(' + value + ')}</style>';
                    angular.element($document[0].querySelector('head')).append(style);
                }
            });
        }
    };
}
